var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSortAscending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 6C3 5.44772 3.44772 5 4 5H11C11.5523 5 12 5.44772 12 6C12 6.55228 11.5523 7 11 7H4C3.44772 7 3 6.55228 3 6ZM17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289L21.7071 8.29289C22.0976 8.68342 22.0976 9.31658 21.7071 9.70711C21.3166 10.0976 20.6834 10.0976 20.2929 9.70711L19 8.41421V18C19 18.5523 18.5523 19 18 19C17.4477 19 17 18.5523 17 18V8.41421L15.7071 9.70711C15.3166 10.0976 14.6834 10.0976 14.2929 9.70711C13.9024 9.31658 13.9024 8.68342 14.2929 8.29289L17.2929 5.29289ZM3 12C3 11.4477 3.44772 11 4 11H11C11.5523 11 12 11.4477 12 12C12 12.5523 11.5523 13 11 13H4C3.44772 13 3 12.5523 3 12ZM3 18C3 17.4477 3.44772 17 4 17H13C13.5523 17 14 17.4477 14 18C14 18.5523 13.5523 19 13 19H4C3.44772 19 3 18.5523 3 18Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortAscending);
export default __webpack_public_path__ + "static/media/sort-ascending.d0173b6630f83f0a61ba4bc267a686ab.svg";
export { ForwardRef as ReactComponent };